/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
// Mappa stato intervento collegato → testo/stato del pulsante
const STATO_BTN = {
  in_attesa:  { label: 'Richiesta inviata',       colore: '#6B7280' },
  confermato: { label: 'Appuntamento confermato',  colore: '#3B82F6' },
  in_corso:   { label: 'Intervento in corso',      colore: '#8B5CF6' },
};

// Costruisce label, stato e dati precompilati per una manutenzione in scadenza
export function ctaManutenzione(s) {
  // Se esiste un intervento aperto collegato: pulsante che rimanda al dettaglio intervento
  if (s.intervento_stato && STATO_BTN[s.intervento_stato]) {
    return {
      ...STATO_BTN[s.intervento_stato],
      vaiAIntervento: s.intervento_id || null,
      precompilato: null,
    };
  }

  // Altrimenti pulsante attivo che crea la richiesta, copy in base all'urgenza
  const urgente = s.colore === 'rosso' || s.colore === 'scaduta';
  const scaduta = s.colore === 'scaduta';
  const prodottoLabel = [s.prodotto, s.marca, s.modello].filter(Boolean).join(' ');
  const dove = s.ubicazione ? ` (${s.ubicazione})` : '';
  const quando = scaduta
    ? `scaduta da ${Math.abs(s.giorni_rimanenti)} giorni`
    : `in scadenza tra ${s.giorni_rimanenti} giorni`;

  return {
    label: urgente ? 'Richiedi intervento' : 'Fissa appuntamento',
    colore: urgente ? (scaduta ? '#DC2626' : '#EF4444') : '#F59E0B',
    vaiAIntervento: null,
    precompilato: {
      titolo: `${s.manutenzione} - ${prodottoLabel}`,
      descrizione: `Richiesta di ${s.manutenzione.toLowerCase()} per ${prodottoLabel}${dove}, ${quando}.`,
      tipo_problema: 'Manutenzione',
      priorita: urgente ? 'alta' : 'normale',
      prodotto_cliente_id: s.prodotto_id,
      manutenzione_tipo_id: s.manutenzione_tipo_id,
    },
  };
}
